module.exports = __webpack_public_path__ + "static/media/C++.589ce41d.png";